export enum ProposedChangeNoticeTone {
  WARNING = 'warning',
  ERROR = 'error',
}

export interface ProposedChangeNoticeProps {
  tone: ProposedChangeNoticeTone;
  /** Already-translated copy. */
  text: string;
}

export const PROPOSED_CHANGE_NOTICE_ICON: Record<ProposedChangeNoticeTone, string> = {
  [ProposedChangeNoticeTone.WARNING]: 'icon-exclamation-triangle',
  [ProposedChangeNoticeTone.ERROR]: 'icon-exclamation-circle',
};
